// JobBoard.jsx
import React, { useEffect, useId, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from "framer-motion";
import "./styles/ExpandableCard.css";

const WhatsAppIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="24" 
    viewBox="0 0 24 24"
    className="whatsapp-icon"
  >
    <path href="https://chat.whatsapp.com/I8NnmXCpoDk6xtnZCA6hnQ"/>
  </svg>
);

export function JobBoard() {
  const { t } = useTranslation();
  const [active, setActive] = useState(null);

  const jobs = [
    {
      title: t('expandable.jobs.jrAssociate.title'),
      AvailablePosition: "10",
      Experience: t('expandable.jobs.jrAssociate.experience'),
      type: t('expandable.jobs.jrAssociate.type'),
      description: t('expandable.jobs.jrAssociate.description'),
    },
    {
      title: t('expandable.jobs.assocCpp.title'),
      AvailablePosition: "10",
      Experience: t('expandable.jobs.assocCpp.experience'),
      type: t('expandable.jobs.assocCpp.type'),
      description: t('expandable.jobs.assocCpp.description'),
    },
    {
      title: t('expandable.jobs.srSoftware.title'),
      AvailablePosition: "8",
      Experience: t('expandable.jobs.srSoftware.experience'),
      type: t('expandable.jobs.srSoftware.type'),
      description: t('expandable.jobs.srSoftware.description'),
    },
    {
      title: t('expandable.jobs.techLead.title'),
      AvailablePosition: "6",
      Experience: t('expandable.jobs.techLead.experience'),
      type: t('expandable.jobs.techLead.type'),
      description: t('expandable.jobs.techLead.description'),
    },
    {
      title: t('expandable.jobs.assocPython.title'),
      AvailablePosition: "2",
      Experience: t('expandable.jobs.assocPython.experience'),
      type: t('expandable.jobs.assocPython.type'),
      description: t('expandable.jobs.assocPython.description'),
    },
    {
      title: t('expandable.jobs.architect.title'),
      AvailablePosition: "2",
      Experience: t('expandable.jobs.architect.experience'),
      type: t('expandable.jobs.architect.type'),
      description: t('expandable.jobs.architect.description'),
    }
  ];
  const ref = useRef(null);
  const id = useId();

  useEffect(() => {
    function onKeyDown(event) {
      if (event.key === "Escape") {
        setActive(false);
      }
    }

    if (active && typeof active === "object") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [active]);

  const handleWhatsAppClick = (number, title) => {
    const message = t('expandable.whatsappMessage', { title });
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://chat.whatsapp.com/I8NnmXCpoDk6xtnZCA6hnQ`, '_blank');
  };

  return (
    <>
      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="overlay"
          />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {active && (
          <div className="modal-container">
            <motion.div
              layoutId={`card-${active.title}-${id}`}
              ref={ref}
              className="modal-content"
            >
              <div className="modal-header">
                <motion.h2 layoutId={`title-${active.title}-${id}`} className="modal-title">
                  {active.title}
                </motion.h2>
                <button 
                  className="modal-close"
                  onClick={() => setActive(null)}
                >
                  ×
                </button>
              </div>
              
              <div className="modal-details">
                <div className="job-meta">
                  <p className="company">{active.company}</p>
                  <p className="location">{active.location}</p>
                  <p className="type">{active.type}</p>
                </div>
                
                <div className="job-description">
                  <pre>{active.description}</pre>
                </div>

                <button 
                  className="whatsapp-button"
                  onClick={() => handleWhatsAppClick(active.whatsappNumber, active.title)}
                >
                  <WhatsAppIcon /> {t('expandable.applyNow')}
                </button>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      <div className="jobs-container">
        {/* <h1 className="jobs-title">Open Positions</h1> */}
        {jobs.map((job) => (
          <motion.div
            layoutId={`card-${job.title}-${id}`}
            key={`card-${job.title}-${id}`}
            onClick={() => setActive(job)}
            className="job-card"
          >
            <div className="job-card-content">
              <motion.h3 layoutId={`title-${job.title}-${id}`} className="job-card-title">
                {job.title}
              </motion.h3>
              <div className="job-card-meta">
                <span className="company">{t('expandable.availablePositions')} {job.AvailablePosition}</span>
                <span className="company">{t('expandable.experience')} {job.Experience}</span>
                <span className="type">{job.type}</span>
              </div>
            </div>
            <button className="view-details-button">
              {t('expandable.viewDetails')}
            </button>
          </motion.div>
        ))}
      </div>
    </>
  );
}